module.exports = __webpack_public_path__ + "static/media/SunElf.560dfffe.png";